import { render, staticRenderFns } from "./creatorIncentives.vue?vue&type=template&id=860aef3a&scoped=true"
import script from "./creatorIncentives.vue?vue&type=script&lang=js"
export * from "./creatorIncentives.vue?vue&type=script&lang=js"
import style0 from "./creatorIncentives.vue?vue&type=style&index=0&id=860aef3a&prod&lang=css"
import style1 from "./creatorIncentives.vue?vue&type=style&index=1&id=860aef3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860aef3a",
  null
  
)

export default component.exports